// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1nRsd","title":"BackImages_title__7w11i","images":"BackImages_images__2iP0s"};